import { Directive, ElementRef, Input } from "@angular/core";
declare var $: any;

@Directive({
    selector : '[tooltip]',
    // host : {
    //     '(mouseenter)' : 'preventDefault($event)'
    //   }
  })
  export class TooltipDirective {

    @Input('data-tip') dataTip;

    dataTipAttr: string = null;
     constructor(public el: ElementRef){
        // this.dataTipAttr = el.nativeElement.getAttribute('data-tip');
     }
    
     
    ngOnInit(event) {
        setTimeout(() => {
            this.dataTipAttr = this.el.nativeElement.getAttribute('data-tip');
            let html = $('#' + this.dataTipAttr).html()
            console.log("method" + html)
            $(this.dataTip).tooltip(
                {
                    html: true,
                    trigger: "hover",
                    title: $('#' + this.dataTipAttr).html(),
                    customClass: 'tooltip-custom'
                });
        }, 300)
    }



  }